import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/HotelAuroraGame/scenes/GameIntro';

interface PhaserHotelAuroraGameProps {
    onComplete: () => void;

}

interface PhaserHotelAuroraGameState {
}

const gameConfig: GameConfig = {
    title: "Landscaping Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};

class PhaserHotelAuroraGame extends React.Component<PhaserHotelAuroraGameProps, PhaserHotelAuroraGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserHotelAuroraGameProps) {
        super(props);
        bindAllOfThis(this, PhaserHotelAuroraGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig}  onComplete={this.props.onComplete}/>
        </div>);
    }
}

export default PhaserHotelAuroraGame;



// WEBPACK FOOTER //
// ./src/games/HotelAuroraGame/Main.tsx